import React, { FC, memo } from 'react'

import { Marquee } from '@/components/Marquee'
import { NameText, TileNameElem } from '@/components/Tiles/styles'

export const TileNameRaw: FC<{
  className?: string
  text?: string
  isFocused?: boolean
  isMultiline?: boolean
}> = ({ className, text, isFocused, isMultiline }) => {
  return (
    <TileNameElem className={className}>
      {isMultiline ? (
        <NameText>{text}</NameText>
      ) : (
        <Marquee play={isFocused}>{text}</Marquee>
      )}
    </TileNameElem>
  )
}

export const TileName = memo(TileNameRaw)
